import { BrowserRouter, Routes, Route,useLocation } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./components/Home/Home";
import Newsletter from "./components/Footer/Newsletter/Newsletter";
import Contact from "./components/Contact/Contact";

function App() {
  return (
    <BrowserRouter>
      <AppContextWrapper />
    </BrowserRouter>
  );
}

function AppContextWrapper() {
  const location = useLocation();
  const isContactPath = location.pathname === '/contact';
  const path = location.pathname ==='/';
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      {path ? <Newsletter/>: null}
      {isContactPath ? null : <Footer />}
    </>
  );
}

export default App;
